<ion-list>
  @if (!announcement.isRead && announcement.publishedByUser.id !== currentUser.id) {
    <ion-item button (click)="setRead(announcement)" lines="none">
      <ion-button color="danger" size="small" fill="clear">
        <ion-icon name="checkmark-outline"></ion-icon>
      </ion-button>
      <ion-label>Označit jako přečtené</ion-label>
    </ion-item>
  }

  @if (announcement.isRead && announcement.publishedByUser.id !== currentUser.id) {
    <ion-item button (click)="setUnread(announcement)" lines="none">
      <ion-button color="danger" size="small" fill="clear">
        <ion-icon name="checkmark-outline"></ion-icon>
      </ion-button>
      <ion-label>Označit jako nepřečtené</ion-label>
    </ion-item>
  }

  @if (canEdit) {
    <ion-item button (click)="edit()" lines="none">
      <ion-button color="danger" fill="clear">
        <ion-icon name="pencil"></ion-icon>
      </ion-button>
      <ion-label>Upravit</ion-label>
    </ion-item>
  }

  @if (canEdit && isPublished()) {
    <ion-item button (click)="archive()" lines="none">
      <ion-button color="danger" fill="clear">
        <ion-icon name="eye-off-outline"></ion-icon>
      </ion-button>
      <ion-label>Archivovat</ion-label>
    </ion-item>
  }

  @if (canEdit && !isPublished()) {
    <ion-item button (click)="publish()" lines="none">
      <ion-button color="danger" fill="clear">
        <ion-icon name="eye-outline"></ion-icon>
      </ion-button>
      <ion-label>Publikovat</ion-label>
    </ion-item>
  }

  @if (canEdit) {
    <ion-item button (click)="delete()" lines="none">
      <ion-button color="danger" fill="clear">
        <ion-icon name="trash"></ion-icon>
      </ion-button>
      <ion-label>Smazat</ion-label>
    </ion-item>
  }
</ion-list>
